// extracted by mini-css-extract-plugin
export default {"container":"theme_container__2OqmU","otpContainer":"theme_otpContainer__oYZH3","resendOtp":"theme_resendOtp__hkr6+"};